export default "__VITE_ASSET__CaKPxixC__"